import OrganizationPicker from "../../../core/components/OrganizationPicker/OrganizationPicker";
import { Field, useFormikContext } from 'formik';
import { UserRole } from 'legoland-sdk/dist/experimental';
import { useEffect } from 'react';
import { FormGroup, Input, Label, Text } from 'tombac';
import { ContractType } from "../../contractTypes";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContractOrganizationFields = ({
  contract,
  intent,
  isCloneUsersChecked,
  onOrganizationSelect,
  selectedOrganization,
  userRole
}) => {
  const {
    errors,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    touched,
    values
  } = useFormikContext();
  const hasUsers = contract.users?.length > 0;
  const canSelectOrganization = !hasUsers || intent === 'clone' && !isCloneUsersChecked;

  // Reset organization to the default value when disabling the picker
  useEffect(() => {
    if (!canSelectOrganization) {
      setFieldValue('organization.id', contract.organization?.id ?? null);
      setFieldValue('organization.sapId', contract.organization?.sapId ?? '');
      setFieldTouched('organization.id', false);
      setFieldTouched('organization.sapId', false);
    }
  }, [canSelectOrganization, setFieldTouched, setFieldValue]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OrganizationPicker, {
      caption: canSelectOrganization ? undefined : intent === 'clone' ? /*#__PURE__*/_jsx(Text, {
        size: "s",
        variant: "secondary",
        children: "Cannot be changed when cloning with users"
      }) : false,
      disabled: !canSelectOrganization || isSubmitting,
      label: "Organization",
      name: "organization.id",
      onOrganizationDetails: organization => {
        onOrganizationSelect(organization);
        setFieldValue('organization.sapId', organization?.sapId ?? '');
        setFieldTouched('organization.sapId', false);
      },
      required: true,
      "data-sentry-element": "OrganizationPicker",
      "data-sentry-source-file": "ContractOrganizationFields.tsx",
      "data-sentry-element": "OrganizationPicker"
    }), selectedOrganization && userRole !== UserRole.Distributor && /*#__PURE__*/_jsx(FormGroup, {
      $gridArea: "sap-id",
      error: touched.organization?.sapId && errors.organization?.sapId,
      htmlFor: "field-sap-id",
      label: /*#__PURE__*/_jsx(Label, {
        htmlFor: "organization-select",
        required: !selectedOrganization?.sapId && (values.type === ContractType.License || values.type === ContractType.Distribution),
        variant: touched.organization?.sapId && errors.organization?.sapId ? 'danger' : 'default',
        children: "Organization SAP ID"
      }),
      children: selectedOrganization?.sapId ? /*#__PURE__*/_jsx(Text, {
        $alignItems: "center",
        $boxSizing: "border-box",
        $display: "flex",
        $height: "40u",
        $pt: "0.2em",
        as: "div",
        children: selectedOrganization.sapId
      }) : /*#__PURE__*/_jsx(Field, {
        as: Input,
        id: "field-sap-id",
        invalid: Boolean(touched.organization?.sapId && errors.organization?.sapId),
        name: "organization.sapId"
      })
    })]
  });
};